export default {name:'家具',category:['建筑设计','室内'],content:{couch:{name:'长椅'},chair:{name:'椅子'},table:{name:'桌子'},window:{name:'窗户'},carpet:{name:'地毯'}}};